import React, { useState } from 'react'
import { DEFAULT_LANG } from 'config/languages'
import FontAwesome from 'components/FontAwesome'
import Link from 'components/Link'
import useBlockScroll from 'utils/hooks/useBlockScroll'
import {
   MenuElement,
   StyledActiveMenu,
   StyledController,
   StyledMenu,
   StyledMobileNav,
   StyledNavigation,
   StyledControlBtn,
   StyledThemeIcon,
} from './styles'
import LangSelector from './LangSelector'

export function MobileNav({ opened, handleDarkMode, searchPlaceholder, languages, lang, path, menu, handleMenuOpened }) {
   useBlockScroll(opened)

   const [activeMenu, setActiveMenu] = useState('')
   const langPrefix = lang === DEFAULT_LANG ? '' : `/${lang}`

   function renderMenuContent() {
      if (activeMenu === 'lang') {
         return <LangSelector languages={languages} path={!langPrefix ? path : path.replace(langPrefix, '')} />
      }
      return null
   }
   return (
      <StyledMobileNav $isOpen={opened}>
         <div>
            <StyledController $isActive={!!activeMenu}>
               <div>
                  <StyledControlBtn
                     onClick={() => setActiveMenu((prevState) => (prevState === 'lang' ? '' : 'lang'))}
                     isActive={activeMenu === 'lang' ? 'true' : 'false'}
                     aria-label="Open language menu"
                  >
                     <FontAwesome icon="globe" />
                  </StyledControlBtn>
                  <StyledControlBtn onClick={handleDarkMode} aria-label="change theme">
                     <StyledThemeIcon />
                  </StyledControlBtn>
                  <Link 
                     href={lang === DEFAULT_LANG ? `/search` : `/${lang}/search`} 
                     type="internal"
                     onClick={() => handleMenuOpened(false)}
                  >
                     <StyledControlBtn
                        aria-label="Open search"
                     >
                        <FontAwesome icon="search" />
                     </StyledControlBtn>
                  </Link>
               </div>
               <StyledActiveMenu $isActive={!!activeMenu}>{renderMenuContent()}</StyledActiveMenu>
            </StyledController>
            <StyledNavigation>
               <StyledMenu>
                  {Array.isArray(menu) &&
                     menu.map((item) => {
                        if (item.type === 'internal') {
                           const linkUrl = lang === DEFAULT_LANG ? item.url : `/${lang}${item.url}`
                           return (
                              <MenuElement
                                 key={item.id}
                                 className={linkUrl.includes('#') && linkUrl.indexOf(`${path}#`) >= 0 ? 'active' : ''}
                              >
                                 <Link {...item} url={linkUrl} activeclassname="is-active" id={`mobile_${item.id}`} />
                              </MenuElement>
                           )
                        }
                        return (
                           <MenuElement key={item.id}>
                              <Link {...item} id={`mobile_${item.id}`} />
                           </MenuElement>
                        )
                     })}
               </StyledMenu>
            </StyledNavigation>
         </div>
      </StyledMobileNav>
   )
}
